import {
    loadSCFIntegrator,
    reset as scfReset,
    start as scfStart
} from './scf';
import {
    listenForIframeResize,
    postIframeSize
} from './iframe-resize.js';

listenForIframeResize();
postIframeSize();

document.addEventListener('DOMContentLoaded', async function () {
    const nodeIframe = document.getElementById('scf-iframe');
    const scfTokenResponse = await getSCFToken();

    loadSCFIntegrator(
        nodeIframe,
        scfTokenResponse.lang,
        scfTokenResponse.iframe_src,
        scfAutoDispatch,
        scfDispatch,
        scfNavigationStateChange,
        scfTokenResponse.scf.access_token
    );

    document.getElementById('vehicle-price-form').onsubmit = async (e) => {
        e.preventDefault();
        if (!validateVehiclePriceForm()) {
            return;
        }

        const priceResponse = await getAutoIPrice(new FormData(e.target));
        const mileageGroup = document.querySelector('.mileage-group');
        const errMsgElem = document.querySelector('.mileage-group .error-message');

        if (priceResponse.status_message === 'ok') {
            errMsgElem.textContent = '';
            mileageGroup.classList.remove('invalid');
            setValueToField(priceResponse);
            goToStep(2);
        } else {
            errMsgElem.textContent = priceResponse.status_message;
            mileageGroup.classList.add('invalid');
        }
    };
    document.getElementById('contact-form').onsubmit = async (e) => {
        e.preventDefault();
        if (!contactFormValidation()) {
            return;
        }
        collectData(new FormData(e.target));
        goToStep(3);
    };

    const resetLinks = document.querySelectorAll('.reset-link a');
    for (let i = 0; i < resetLinks.length; ++i) {
        resetLinks[i].onclick = (e) => {
            e.preventDefault();
            disableClickOfIndicators();
            goToStep(0);
            scfReset();
            resetForms();
        }
    }

    const langExpand = document.querySelectorAll('.language > span');
    for (let i = 0; i < langExpand.length; ++i) {
        langExpand[i].addEventListener('click', () => {
            const langPopup = document.querySelectorAll('.language .lang-popup');
            for (let j = 0; j < langPopup.length; ++j) {
                langPopup[j].classList.toggle('lang-hidden');
            }
        });
    }
});

async function getSCFToken() {
    return await fetch('/scf-token', {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').getAttribute('content')
        },
        method: 'POST',
    }).then(response => response.json());
}

async function getAutoIPrice(data) {
    return await fetch('/web-service-bewertung', {
        method: 'POST',
        body: data
    }).then(response => response.json())
}

async function collectData(data) {
    return await fetch('/requests-builder', {
        method: 'POST',
        body: data
    }).then(response => response.json())
}

function scfAutoDispatch(data) {
    if (data.constructor === Array && typeof data[0] !== 'undefined' && typeof data[0].firstAdmission !== 'undefined') {
        let __date  = new Date(data[0].firstAdmission).getFullYear();
        let __today = new Date().getFullYear();
        let __errorsBlock = document.querySelector('.error_10_years');

        if ((__today - __date) > 10) {
            scfStart();
            __errorsBlock.classList.remove('hidden');
            __errorsBlock.textContent = __e.step[1].form.error.year.higher;
            goToStep(0);
        } else {
            __errorsBlock.classList.add('hidden');
            __errorsBlock.textContent = '';
        }
    }

    if (data.hasOwnProperty('vehicle')) {
        setValueToField(data.vehicle);
            const formElems =  document.getElementById('vehicle-price-form');
            const formData  = new FormData(formElems);
            formData.set('mileage', "30000"); // set default value

            getAutoIPrice(formData).then(priceResponse => {
                if (priceResponse.status_code === 4) { // 4 - Vehicle is blocked for rating (No rating or No rating yet)
                    let __errorsBlock = document.querySelector('.error_10_years');
                    // goToStep(0);
                    scfStart();
                    __errorsBlock.classList.remove('hidden');
                    __errorsBlock.textContent = __e.step[1].form.error.special_vehicle;
                    if (window.screen.width <= 600) {
                        let stepBar = document.getElementById('step-bar-dots');
                        stepBar.scrollIntoView();
                    } else {
                        document.querySelector('.step0').scrollIntoView();
                    }
                }
                else {
                    goToStep(1);
                }
            });
    }
}

function scfNavigationStateChange(data) {
    if (data.hasOwnProperty('currentIndex')) {
        const elem = document.querySelector('.step0 .reset-link');
        if (data.currentIndex == '1') {
            elem.classList.remove('hidden');
        } else {
            elem.classList.add('hidden');
        }
    }
}

function scfDispatch(data) {

}

function goToStep(stepNumber) {
    let stepSection = document.getElementById('step-section');
    let stepsToHide = document.getElementsByClassName('step');
    let stepToShow = document.getElementsByClassName(`step${stepNumber}`);
    let indicators = document.getElementsByClassName('step-bar-dot');
    let sectionsToHide = document.getElementsByClassName('hide-for-step');

    for (let i = 0; i < indicators.length; ++i) {
        indicators[i].classList.remove('active');
    }

    for (let i = 0; i <= stepNumber; ++i) {
        indicators[i].onclick = function () {
            goToStep(i)
        };
    }

    indicators[stepNumber].classList.add('active');

    for (let i = 0; i < stepsToHide.length; ++i) {
        stepsToHide[i].classList.add('hidden');
    }
    for (let i = 0; i < stepToShow.length; ++i) {
        stepToShow[i].classList.remove('hidden');
    }
    for (let i = 0; i < sectionsToHide.length; ++i) {
        if (stepNumber === 2 || stepNumber === 3) {
            sectionsToHide[i].classList.add('hidden');
        } else {
            sectionsToHide[i].classList.remove('hidden');
        }
    }
}

function disableClickOfIndicators() {
    const indicators = document.getElementsByClassName('step-bar-dot');
    for (let i = 0; i < indicators.length; ++i) {
        indicators[i].onclick = null;
    }
}

function setValueToField(params) {
    /* key = key of parametrs, value = element selector */
    const elemToSetValue = {
        'brand': 'brand_name',
        'model': 'model',
        'modelYear': 'year',
        'type': 'body_type',
        'version': 'engine',
        'gearbox': 'transmission',
        'firstAdmission': 'first_admission_date',
        'mileage': 'mileage',
        'price_min': 'price_min',
        'price_max': 'price_max',
        'autoiCode': 'identifier',
        'description': 'car',
        'name': 'dealer-name',
        'street': 'dealer-street',
        'zip': 'dealer-zip',
        'city': 'dealer-city',
        'url': 'dealer-link',
        'vcc_id': 'retailer',
    };

    for (let i in elemToSetValue) {
        const elems = document.querySelectorAll(`input[type=hidden][name=${elemToSetValue[i]}]`);
        for (let j = 0; j < elems.length; ++j) {
            if (params.hasOwnProperty(i)) {
                elems[j].value = params[i];
            }
        }

        const elems2 = document.querySelectorAll(`span.${elemToSetValue[i]}`);
        for (let j = 0; j < elems2.length; ++j) {
            if (params.hasOwnProperty(i)) {
                if (elemToSetValue[i] === 'price_min' || elemToSetValue[i] === 'price_max') {
                    elems2[j].innerText = params[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '’');
                } else if (elemToSetValue[i] === 'mileage') {
                    elems2[j].innerText = params[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '’');
                } else if (elemToSetValue[i] === 'dealer-link') {
                    elems2[j].querySelector('a').setAttribute('href', params[i]);
                } else {
                    elems2[j].innerText = params[i];
                }
            }
        }
    }
}

function validateVehiclePriceForm() {
    const errMsgElem   = document.querySelector('.mileage-group .error-message');
    const mileageGroup = document.querySelector('.mileage-group');
    const yearVal      = parseInt(document.querySelector('#vehicle-price-form input[name=year]').value.trim());
    const mileageVal   = parseInt(document.querySelector('#vehicle-price-form input[name=mileage]').value.trim());

    if (isNaN(mileageVal)) {
        errMsgElem.textContent = __e.step[1].form.error.mileage.lower;
        mileageGroup.classList.add('invalid');
        return false;
    }

    if (((new Date().getFullYear()) - yearVal) > 10) {
        errMsgElem.textContent = __e.step[1].form.error.year.higher;
        mileageGroup.classList.add('invalid');
        return false;
    }

    if (mileageVal > 180000) {
        errMsgElem.textContent = __e.step[1].form.error.mileage.higher;
        mileageGroup.classList.add('invalid');
        return false;
    } else if (mileageVal < 4000) {
        errMsgElem.textContent = __e.step[1].form.error.mileage.lower;
        mileageGroup.classList.add('invalid');
        return false;
    }

    mileageGroup.classList.remove('invalid');
    errMsgElem.textContent = '';
    return true;
}

function contactFormValidation() {
    let form = document.querySelector('#contact-form');
    let vinCode = form.querySelector('input[name=vinCode]').value;
    let firstName = form.querySelector('input[name=firstName]').value;
    let lastName = form.querySelector('input[name=lastName]').value;
    let email = form.querySelector('input[name=email]').value;
    let emailConfirmation = form.querySelector('input[name=email-verification]').value;
    let phone = form.querySelector('input[name=telephone]').value;
    let address = form.querySelector('input[name=address]').value;
    let retailer = form.querySelector('input[name=retailer]').value;
    let fields = form.querySelectorAll('.field-group .field');
    let messages = form.querySelectorAll('.field-group .error-message');
    let retailerMessage = form.querySelector('.field-group .error-message.retailer-error');
    let valid = true;

    /* Vin Code Validation */
    const regVin = /^[A-Za-z0-9]*$/;
    if (vinCode && !regVin.test(vinCode)) {
        document.querySelector('.field-group.vin-conde-group .error-message').textContent = __e.step[2].form.error.vin;
        document.querySelector('.field-group.vin-conde-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.vin-conde-group .error-message').textContent = '';
        document.querySelector('.field-group.vin-conde-group').classList.remove('invalid');
    }
    /* First Name Validation */
    const regName = /^[a-z\u00C0-\u00ff ,.'-]+$/i;
    if (!regName.test(firstName)) {
        document.querySelector('.field-group.first-name-group .error-message').textContent = __e.step[2].form.error.fname;
        document.querySelector('.field-group.first-name-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.first-name-group .error-message').textContent = '';
        document.querySelector('.field-group.first-name-group').classList.remove('invalid');
    }
    /* Last Name Validation */
    if (!regName.test(lastName)) {
        document.querySelector('.field-group.last-name-group .error-message').textContent = __e.step[2].form.error.lname;
        document.querySelector('.field-group.last-name-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.last-name-group .error-message').textContent = '';
        document.querySelector('.field-group.last-name-group').classList.remove('invalid');
    }
    /* Email Validation */
    const regMail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

    if (!regMail.test(email)) {
        document.querySelector('.field-group.email-group .error-message').textContent = __e.step[2].form.error.email;
        document.querySelector('.field-group.email-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.email-group .error-message').textContent = '';
        document.querySelector('.field-group.email-group').classList.remove('invalid');
    }
    if (email !== emailConfirmation) {
        document.querySelector('.field-group.email-validation-group .error-message').textContent = __e.step[2].form.error.confirm;
        document.querySelector('.field-group.email-validation-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.email-validation-group .error-message').textContent = '';
        document.querySelector('.field-group.email-validation-group').classList.remove('invalid');
    }
    /* Phone validation */
    const regPhone = /^[+]?\d+$/;
    if (phone && (!regPhone.test(phone) || !phone.startsWith('+41'))) {
        document.querySelector('.field-group.phone-group .error-message').textContent = __e.step[2].form.error.phone;
        document.querySelector('.field-group.phone-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.phone-group .error-message').textContent = '';
        document.querySelector('.field-group.phone-group').classList.remove('invalid');
    }
    /* Address validation */
    const regAddress = /^[a-zA-Z0-9\u00C0-\u00ff\s,.'-]*$/;
    if (address && !regAddress.test(address)) {
        document.querySelector('.field-group.address-group .error-message').textContent = __e.step[2].form.error.address;
        document.querySelector('.field-group.address-group').classList.add('invalid');
        valid = false;
    } else {
        document.querySelector('.field-group.address-group .error-message').textContent = '';
        document.querySelector('.field-group.address-group').classList.remove('invalid');
    }
    /* Retailer validation */
    if (!retailer) {
        retailerMessage.textContent =  __e.step[2].form.error.dealer;
        valid = false;
    } else {
        retailerMessage.textContent = '';
    }

    for (let i = 0; i < fields.length; i++) {
        if (!fields[i].value) {
            messages[i].textContent = __e.step[2].form.error.empty[i];
            form.querySelectorAll('.field-group')[i].classList.add('invalid');
            valid = false;
        } else if (!messages[i].textContent) {
            messages[i].textContent = '';
            form.querySelectorAll('.field-group')[i].classList.remove('invalid');
        }
    }
    if ( valid === false ) {
        document.getElementById('contact-form').scrollIntoView();
    }

    return valid;
}

function resetForms() {
    const errorsToReset = document.querySelectorAll('.error-message');
    for (let i = 0; i < errorsToReset.length; ++i) {
        errorsToReset[i].textContent = '';
    }

    const fieldsToReset = document.querySelectorAll('#vehicle-price-form input');
    for (let i = 0; i < fieldsToReset.length; ++i) {
        if (fieldsToReset[i].name === '_token') continue;
        fieldsToReset[i].value = '';
    }
}
